import styles from "./styles.module.scss";
import primaryComponents from "../../../../components/primaryComponents";
import { useNavigate } from "react-router-dom";
import {
  CloseIcon,
  OrderNoteIcon,
  PendBtnIcon,
} from "../../../../assets/svgIcons";
import { CheckoutGroup } from "../CheckoutGroup";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../..";
import { useCheckoutView } from "./useCheckoutView";
import React, { useEffect, useState } from "react";
import { CartPriceSummary } from "../CartPriceSummary";
import { PaymentsGroup } from "./PaymentsGroup";
import { useValidation } from "./useValidation";
import { formatCurrency, getValidationErrorMessage } from "../../../../helpers";
import { useDispatch } from "react-redux";
import { setApiErrorMessage } from "../../../../store/modules/apiErrorHandler";
import { addStoreWallet } from "../../../../store/modules/checkoutInfo";
import { RoutedModal } from "../../../common";
import { PaymentViaCardPrompt } from "../PaymentPrompt/PaymentViaCardPrompt";
import { PaymentViaTransferPrompt } from "../PaymentPrompt/PaymentViaTransferPrompt";
import { AddCustomerToCheckout } from "../CheckoutCustomer/AddCustomerToCheckout";
import { WalletDetailsForm } from "./StoreWalletPayment/WalletDetailsForm";
import { CreditDetails } from "./CreditPayment/CreditDetailsForm";
import { ConfirmReceiptGeneration } from "../ConfirmReceiptGeneration";

export const CheckoutView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    checkoutOptions,
    paymentMethod,
    isCreatingOrder,
    orderNote,
    customer,
    store_wallet,
    payment,
    totalCalculatedPrice,
    storeDetails,
    isPendingCheckout,
    orderDetails,
    isLoadingOrderDetails,
    views,
    submitOrder,
    mainStoreDetails,
    setCustomerInfo,
    updatePayment,
    setStoreWallet,
    setViews,
    processOrder,
    handlePendCheckout,
    setOrderNote,
    setPaymentMethod,
    isAccountRequired,
    ledger_account_id,
  } = useCheckoutView();
  const orderAmount =
    orderDetails?.total_amount || totalCalculatedPrice?.toFixed(2);
  const creditAmount = Number(
    payment?.pay_with_split?.credit_amount || orderAmount,
  );

  const [errorsView, setErrorsView] = useState({
    isStoreWallet: false,
    isCustomer: false,
    isCredit: false,
    isCreditLimit: false,
    isConfirmReceipt: false,
  });
  const {
    formState: { errors },
    setValue,
    clearErrors,
    handleSubmit,
  } = useValidation({
    requireCustomer: storeDetails?.require_customer_on_checkout || false,
    requireLedgerAccount: isAccountRequired,
    ledger_account_id: ledger_account_id ? `${ledger_account_id}` : "",
  });

  const reValidateCreditLimit = () => {
    const creditLimit = Number(
      customer?.credit_limit || mainStoreDetails?.credit_limit || 0,
    );

    const outstandingBalance = Number(customer?.outstanding_balance || 0);

    const hasExceededCreditLimit =
      creditAmount > creditLimit - outstandingBalance;

    setValue("hasExceedCreditLimt", hasExceededCreditLimit);
  };

  useEffect(() => {
    if (errors?.wallet_id)
      return setErrorsView((prev) => ({ ...prev, isStoreWallet: true }));

    if (
      errors?.customer_id &&
      (payment?.pay_with_credit || payment?.pay_with_split?.credit_amount)
    )
      return setErrorsView((prev) => ({ ...prev, isCredit: true }));

    if (errors?.customer_id)
      return setErrorsView((prev) => ({ ...prev, isCustomer: true }));

    if (errors?.hasExceedCreditLimt)
      return setErrorsView((prev) => ({ ...prev, isCreditLimit: true }));

    if (errors)
      dispatch(
        setApiErrorMessage({ message: getValidationErrorMessage(errors) }),
      );
  }, [errors]);

  useEffect(() => {
    if (customer) {
      reValidateCreditLimit();
      setValue("customer_id", customer?.customer_id);
      return;
    }
    setValue("customer_id", "");
    dispatch(addStoreWallet(null));
  }, [customer]);

  useEffect(() => {
    if (store_wallet) return setValue("wallet_id", store_wallet?.wallet_id);
    setValue("wallet_id", "");
  }, [store_wallet]);

  useEffect(() => {
    if (payment?.pay_with_split?.store_wallet_amount)
      return setValue(
        "splitStoreWalletAmount",
        payment?.pay_with_split?.store_wallet_amount,
      );
    setValue("splitStoreWalletAmount", "");
  }, [payment?.pay_with_split?.store_wallet_amount]);

  useEffect(() => {
    if (payment?.pay_with_split?.credit_amount) {
      reValidateCreditLimit();
      setValue("splitCreditAmount", payment?.pay_with_split?.credit_amount);
      return;
    }
    setValue("splitCreditAmount", "");
  }, [payment?.pay_with_split?.credit_amount]);

  useEffect(() => {
    reValidateCreditLimit();
  }, [payment?.pay_with_credit]);

  useEffect(() => {
    setValue(
      "ledger_account_id",
      ledger_account_id ? `${ledger_account_id}` : "",
      { shouldValidate: true },
    );
    if (ledger_account_id) {
      clearErrors("ledger_account_id");
    }
  }, [ledger_account_id, clearErrors, setValue]);

  useEffect(() => {
    setValue("requireLedgerAccount", isAccountRequired);
  }, [isAccountRequired]);

  useEffect(() => {
    if (paymentMethod) {
      setValue("paymentMethod", paymentMethod);
      if (
        !["transfer", "card", "split"].includes(paymentMethod) ||
        ledger_account_id
      ) {
        clearErrors("ledger_account_id");
      }
    }
  }, [paymentMethod, ledger_account_id, clearErrors]);

  // useEffect(() => {
  //   if (!paymentMethod || orderDetails) {
  //     const checkoutItem = checkoutOptions?.[0];
  //     setPaymentMethod(checkoutItem?.value, checkoutItem?.key);
  //     setValue("paymentMethod", checkoutItem?.value);
  //   }
  // }, [orderDetails]);

  return (
    <>
      <div className={styles.checkoutView}>
        <div className={styles.checkoutView__header}>
          <h4 className="mb-0">Charge Customer</h4>

          <div className="d-flex" style={{ gap: "7px" }}>
            <primaryComponents.Button
              classNames={`btn btn--outline-yellow ${styles.hideOnMobile}`}
              onClick={() => handlePendCheckout()}
              isLoading={isPendingCheckout}
              loadingText="Pending..."
            >
              <PendBtnIcon className="mr-1" />
              Pend Checkout
            </primaryComponents.Button>
            <primaryComponents.Button
              style={{ padding: "0 10px" }}
              classNames={"btn btn--outline"}
              onClick={() => navigate(-1)}
            >
              <CloseIcon
                className="dark--text mr-1"
                style={{ fontSize: "20px" }}
              />
              Close
            </primaryComponents.Button>
          </div>
        </div>

        <secondaryComponents.LoaderHelper
          classNames={"mt-5"}
          isLoading={isLoadingOrderDetails}
        >
          <div className={styles.checkoutView__body}>
            <div className={styles.checkoutView__body__left}>
              <div className={styles.paymentMethodView}>
                <div className="mb-4">
                  <h5>Select Payment Method</h5>
                  <div className={styles.paymentMethod}>
                    {checkoutOptions?.map((checkoutItem, index) => (
                      <React.Fragment key={index}>
                        <secondaryComponents.NavigateWithPermission
                          permissionParentKey={
                            checkoutItem?.permissionParentKey
                          }
                          permissionChildKey={checkoutItem?.permissionChildKey}
                          showOnLocalSetup={checkoutItem?.showOnLocalSetup}
                        >
                          <primaryComponents.BoxedRadioInput
                            id={checkoutItem?.value}
                            value={checkoutItem?.value}
                            isChecked={checkoutItem?.value === paymentMethod}
                            setRadioValue={(value) => {
                              setPaymentMethod(value, checkoutItem?.key);
                              setValue("paymentMethod", checkoutItem?.value);
                            }}
                            name={"checkoutPayMethod"}
                            isControlled={true}
                          >
                            <span>{checkoutItem?.name}</span>
                          </primaryComponents.BoxedRadioInput>
                        </secondaryComponents.NavigateWithPermission>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
                <div className={styles.hideOnMobile}>
                  <h5>Customer&apos;s Order Information</h5>
                  <CheckoutGroup
                    storeDetails={storeDetails}
                    style={{ borderRadius: "4px" }}
                    btnStyle={{ height: "55px", background: "white" }}
                  />
                </div>

                <div
                  className={`${globalStyles.cardWithBackground} white`}
                  style={{ padding: "5px 10px 1px 10px" }}
                >
                  <primaryComponents.TextArea
                    value={orderNote}
                    placeholder={"Add extra informations"}
                    label={
                      <span className="d-flex align-items-end">
                        <OrderNoteIcon color={"black"} width="20" height="20" />{" "}
                        <span className="ml-2">Order Note</span>
                      </span>
                    }
                    floatError={false}
                    onChange={({ target: { value } }) => {
                      setOrderNote(value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.checkoutView__body__right}>
              <PaymentsGroup
                storeDetails={storeDetails}
                isAccountRequired={isAccountRequired}
                ledgerAccountError={errors?.ledger_account_id?.message}
              />
              <div className="mt-auto">
                <CartPriceSummary
                  showExtraBtn={true}
                  orderDetails={orderDetails}
                />
              </div>
            </div>
          </div>

          <div className={styles.checkoutView__bottom}>
            <primaryComponents.Button
              classNames={`btn btn--primary font-weight-bold cover ${styles.chargeBtn}`}
              isLoading={isCreatingOrder}
              isDisabled={isCreatingOrder || !paymentMethod}
              loadingText={"Proccessing..."}
              onClick={handleSubmit(() => {
                if (mainStoreDetails?.show_confirmation_on_checkout) {
                  return setErrorsView((prev) => ({
                    ...prev,
                    isConfirmReceipt: true,
                  }));
                }
                processOrder();
              })}
              style={{ height: "70px", fontSize: "25px" }}
            >
              Charge (
              {formatCurrency({
                value: orderAmount,
                currencyCode: storeDetails?.currency_code,
              })}
              )
            </primaryComponents.Button>
          </div>
        </secondaryComponents.LoaderHelper>
      </div>

      <secondaryComponents.Modal
        isActive={errorsView?.isCustomer}
        width={550}
        closeModal={() =>
          setErrorsView((prev) => ({ ...prev, isCustomer: false }))
        }
      >
        <AddCustomerToCheckout
          closeModal={() =>
            setErrorsView((prev) => ({ ...prev, isCustomer: false }))
          }
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={errorsView?.isStoreWallet}
        width={550}
        closeModal={() => {
          if (store_wallet && store_wallet?.session_id)
            return setErrorsView((prev) => ({
              ...prev,
              isStoreWallet: false,
            }));

          setStoreWallet(null);
          setErrorsView((prev) => ({ ...prev, isStoreWallet: false }));
        }}
      >
        <WalletDetailsForm
          setStoreWallet={setStoreWallet}
          closeModal={() =>
            setErrorsView((prev) => ({ ...prev, isStoreWallet: false }))
          }
          amount={payment?.pay_with_store_wallet?.amount}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={errorsView?.isCredit}
        width={550}
        closeModal={() =>
          setErrorsView((prev) => ({ ...prev, isCredit: false }))
        }
      >
        <CreditDetails
          closeModal={() =>
            setErrorsView((prev) => ({ ...prev, isCredit: false }))
          }
          updatePayment={(key, value) => {
            updatePayment({
              key: "pay_with_credit",
              [key]: value,
            });
          }}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={errorsView?.isCreditLimit}
        width={550}
        closeModal={() =>
          setErrorsView((prev) => ({ ...prev, isCreditLimit: false }))
        }
      >
        <secondaryComponents.UpdateCreditLogModal
          orderAmount={creditAmount}
          customer={customer}
          closeModal={() =>
            setErrorsView((prev) => ({ ...prev, isCreditLimit: false }))
          }
          onSuccess={(customerCreditLimit) => {
            setCustomerInfo({ ...customer, credit_limit: customerCreditLimit });
          }}
          type="store"
        />
      </secondaryComponents.Modal>
      <secondaryComponents.Modal
        isActive={
          errorsView?.isConfirmReceipt &&
          mainStoreDetails?.show_confirmation_on_checkout
        }
        width={500}
        closeModal={() =>
          setErrorsView((prev) => ({ ...prev, isConfirmReceipt: false }))
        }
      >
        <ConfirmReceiptGeneration
          closeModal={() =>
            setErrorsView((prev) => ({ ...prev, isConfirmReceipt: false }))
          }
          amount={orderAmount}
          customer={customer}
          storeDetails={storeDetails}
          action={() => processOrder()}
        />
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={views?.isCardPayment}
        width={1000}
        headerTitle="Collect Payment"
        headerDescription="Select a terminal to collect card payment"
        closeModal={() =>
          setViews((prev) => ({ ...prev, isCardPayment: false }))
        }
        style={{ height: "auto" }}
      >
        <PaymentViaCardPrompt
          amount={orderAmount}
          closeModal={() =>
            setViews((prev) => ({ ...prev, isCardPayment: false }))
          }
          chargeOutsideApp={(data) => submitOrder(data)}
        />
      </RoutedModal>

      <RoutedModal
        isActive={views?.isTransferPayment}
        width={1000}
        headerTitle="Collect Payment"
        headerDescription="Select a terminal to receive transfer payment"
        closeModal={() =>
          setViews((prev) => ({ ...prev, isTransferPayment: false }))
        }
        style={{ height: "auto" }}
      >
        <PaymentViaTransferPrompt
          amount={orderAmount}
          closeModal={() =>
            setViews((prev) => ({ ...prev, isTransferPayment: false }))
          }
          chargeOutsideApp={(data) => submitOrder(data)}
        />
      </RoutedModal>
    </>
  );
};
